<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="extra-large"
    modal-alignment="top"
  > 
  <template slot="header">
      <h5 class="modal-title">Actualizar Proceso</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="`accreditationtechnical/modifyScopes/store`"
        
      >
        <div class="col-12">
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col">Expediente</th>
                <th scope="col">Organismo</th>
                <th scope="col">Tipo de acreditación</th>
                <th scope="col">Estado</th>
                <th scope="col">Fecha creación</th>
                <th scope="col" class="text-center" style="width: 10%">
                  Seleccionar proceso
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(process, key) in processes" :key="key">
                <td class="align-middle">
                  {{process.record}}
                </td>
                <td class="">
                  {{
                    process.organization ?
                    process.organization.business_name : ''
                    }}
                </td>
                <td class="">
                  {{process.accreditation_type.name}}
                </td>
                <td class="">
                  {{ process.status.name }}
                </td>
                <td class="">
                  {{ process.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <input 
                    type="checkbox"
                    v-model="inputs.is_modified"
                    :value="process.id"
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
      >
        Actualizar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { axiosGet } from "@/app/helpers/AxiosHelper";
export default {
mixins: [FormMixin, ModalMixin],
props: {
    tableId: String,
    allProcess: Object,
},
data() {
    return {
      preloader: false,
      processes: {},
      inputs: {
        is_modified: [],
      },
      modalId: "modal-edit-process",

    };
  },
  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    
  },
  created() {
    this.dataInfo();
  },
  methods: {
    dataInfo() {
        let url = `/accreditationtechnical/modifyScopes/showModifiedProcess/${this.allProcess.user_id}/${this.allProcess.accreditation_activity_id}?accApp=${this.allProcess.id}`;
      axiosGet(url).then((response) => {
        this.processes = response.data;
      });
    },
    submit() {
      if (this.inputs.is_modified.length == 0) {
        this.$toastr.e(
          "Debe seleccionar al menos un proceso para actualizar"
        );
        return;
      }
      this.inputs['acc_app_id'] = this.allProcess.id;
      this.save(this.inputs);
    },

    afterSuccess(response) {
      this.$toastr.s(this.$t("updated_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },

    // afterFinalResponse() {
    //   this.closeModal();
    //   this.preloader = false;
    // },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

  },
}

</script>

<style>

</style>